import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { HpRespPromoModulePromoItem } from './HpRespPromoModulePromoItem';
import { HpSharedModuleContainer } from '../HpSharedModuleContainer/HpSharedModuleContainer';
import { trackPromoImpressions, trackPromoClick } from './helpers/PromoTracking';
import { HpSharedInViewport } from '../HpSharedInViewport/HpSharedInViewport';

class HpRespPromoModulePrimaryComponent extends Component {
    promoPrimaryModule = get(this.props, 'homepage.promoPrimaryModule');

    handleInitialDisplay = ({ inViewport }) => {
        if (this.promoPrimaryModule && inViewport) {
            const { items } = this.promoPrimaryModule;
            trackPromoImpressions({ items, startingIndex: 0 });
        }
    };

    render() {
        if (!this.promoPrimaryModule) {
            return null;
        }

        const { title, items } = this.promoPrimaryModule;

        return (
            <HpSharedModuleContainer>
                <HpSharedModuleContainer.Header>
                    {title ? (
                        title
                    ) : (
                        <FormattedMessage
                            id="homepage.modules.promo.primary.title"
                            defaultMessage="Curated Weekly"
                        />
                    )}
                </HpSharedModuleContainer.Header>
                <HpSharedInViewport
                    stopWhenInViewport
                    onInViewportChange={this.handleInitialDisplay}
                >
                    <div className="rowFlex">
                        {items.map((promotion, index) => (
                            <HpRespPromoModulePromoItem
                                key={promotion.cmsId}
                                promotion={promotion}
                                className={items.length === 1 ? 'colXs12' : 'colLg6 colXs12'}
                                onClick={() => trackPromoClick({ item: promotion, index })}
                            />
                        ))}
                    </div>
                </HpSharedInViewport>
            </HpSharedModuleContainer>
        );
    }
}

HpRespPromoModulePrimaryComponent.propTypes = {
    homepage: PropTypes.object,
};

export const HpRespPromoModulePrimary = createFragmentContainer(HpRespPromoModulePrimaryComponent, {
    homepage: graphql`
        fragment HpRespPromoModulePrimary_homepage on Homepage {
            promoPrimaryModule: module(type: "promoPrimary") {
                ... on PromoModule {
                    title
                    items {
                        cmsId
                        link
                        imageUrl @skip(if: $isMobile)
                        mobileImageUrl @include(if: $isMobile)
                    }
                }
            }
        }
    `,
});
